import React, { useEffect, useState } from "react";
import { ArrowBackIos } from "@mui/icons-material";
import history from "../../../libs/history.utils";
import styles from "./Style.module.css";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import ImageInfoToolTip from "../../../components/ImageInfo/ImageInfo";
import CustomFileField from "../../../components/FileField/CustomFileField";
import MultiComplete from "../../../components/FormFields/AutoCompleteText/MultiComplete";
import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import UploaderImage from "../../../components/FileComponent/UploaderImage.component";
import { PrimaryButton } from "../../../components/Buttons/PrimaryButton";
import { ButtonBase, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import LogUtils from "../../../libs/LogUtils";
import { useTheme } from "@mui/styles";
import useQuizCreateHook from "./QuizCreate.hook";
import QuestionIncludeForm from "./component/Questions/QuestionIncludes.component";
import CustomDatePicker from "../../../components/FormFields/DatePicker/CustomDatePicker";
import CustomDateTimePicker from "../../../components/FormFields/DatePicker/CustomDateTimePicker";
import useRoles from "../../../hooks/RoleHook";
import Constants from "../../../config/constants";
const QuizCreate = ({location}) => {
  const {
    form,
    errorData,
    changeTextData,
    handleSubmit,
    listData,
    id,
    image,
    onBlurHandler,
    quizRef,
    isSubmitting,
    isActive,
    programList,
    isDuplicate
  } = useQuizCreateHook({location});
  const theme = useTheme();
  const {canAllData} = useRoles(Constants.MODULES.QUIZES_MODULE);
  return (
    <>
      <div className={styles.outerFlex1}>
        <div className={styles.iconButton}>
          <ButtonBase onClick={() => history.goBack()}>
            <ArrowBackIos fontSize={"small"} />{" "}
          </ButtonBase>
          <Typography variant={"title1"}>
            {isDuplicate ? "Add" : id ? "Update" : "Add"} Quiz
          </Typography>
        </div>
      </div>
      <ShadowBox className={styles.contact}>
        <div className={"headerFlex"}>
          <Typography variant={"h5"} className={"heading"} sx={{ mb: 2 }}>
            Quiz Information
          </Typography>
        </div>
        <div className={styles.formFlex}>
          <div className={styles.count}>
            <CustomFileField
              maxSize={10 * 1024 * 1024}
              type={["jpg", "png", "jpeg"]}
              name="image"
              accept={"image/*"}
              error={errorData?.image}
              onChange={(file) => {
                if (file) {
                  changeTextData(file, "image");
                }
              }}
              disabled={isActive && !isDuplicate}
              defaultImage={image}
              value={form?.image}
              render={({ value, url, error, ...rest }) => (
                <UploaderImage
                  placeholder="Upload Image"
                  Banner
                  error={error}
                  value={value}
                  default_image={image}
                  label={
                    <>
                      Upload Image
                      <span style={{ color: theme.palette.error.main }}>*</span>
                    </>
                  }
                  url={url}
                  {...rest}
                />
              )}
            />
            <div className={styles.imageGuide}>
              <Typography variant="subtitle1">Image Guide</Typography>
              <ImageInfoToolTip
                resolution={
                  <div className={styles.new_line}>
                    <div> Resolution 1280px * 720px</div>

                    <div>Image size = 10MB</div>
                  </div>
                }
              />
            </div>
          </div>
          <div className={styles.lowerWrap}>
            <div className={styles.formFlex}>
              <div className={styles.formGroup}>
                <CustomTextField
                  disabled={isActive && !isDuplicate}
                  isError={errorData?.title}
                  errorText={errorData?.title}
                  label={
                    <>
                      Topic Name{" "}
                      <span style={{ color: theme.palette.error.main }}>*</span>
                    </>
                  }
                  value={form?.title}
                  onTextChange={(text) => {
                    changeTextData(text, "title");
                  }}
                  onBlur={() => {
                    onBlurHandler("title");
                  }}
                />
              </div>
            </div>
            <div className={styles.formFlex}>
              <div className={styles.formGroup}>
                <CustomTextField
                  disabled={isActive && !isDuplicate}
                  isError={errorData?.description}
                  errorText={errorData?.description}
                  label={
                    <>
                      Description{" "}
                      <span style={{ color: theme.palette.error.main }}>*</span>
                    </>
                  }
                  multiline
                  rows="3"
                  value={form?.description}
                  onTextChange={(text) => {
                    changeTextData(text, "description");
                  }}
                  onBlur={() => {
                    onBlurHandler("description");
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </ShadowBox>
      <ShadowBox className={styles.contact}>
        <div className={"headerFlex"}>
          <Typography variant={"h5"} className={"heading"} sx={{ mb: 2 }}>
            Question Details
          </Typography>
        </div>
        <QuestionIncludeForm ref={quizRef} isActive={isActive} isDuplicate={isDuplicate}/>
      </ShadowBox>
      <ShadowBox className={styles.contact}>
        <div className={"headerFlex"}>
          <Typography variant={"h5"} className={"heading"} sx={{ mb: 2 }}>
            Additional Details
          </Typography>
        </div>
        <div className={styles.formFlex}>
          <div className={styles.formGroup}>
            <CustomDateTimePicker
              disabled={isActive && !isDuplicate}
              clearable
              label={"Date & time of pushing on app"}
              // minDate={new Date()}
              onChange={(date) => {
                changeTextData(date, "start_date");
              }}
              value={form?.start_date}
              isError={errorData?.start_date}
              minDate={new Date()}
              // views={['year', 'month', 'day', 'hours']}
            />
          </div>
          {canAllData &&( 
          <div className={styles.formGroup}>
            <MultiComplete
              // disabled={isActive}
              disabled={!!location?.state && !isDuplicate}
              isError={errorData?.client_id}
              AutoCompleteList={listData?.CLIENTS ? listData?.CLIENTS : []}
              label="Select Client"
              value={form?.client_id}
              onTextChange={(text) => {
                changeTextData(text, "client_id");
              }}
              enableField={["title"]}
              style={{ marginTop: "-0.5px" }}
            />
          </div>
          )}
        </div>
        <div className={styles.formFlex}>
          <div className={styles.formGroup}>
            <MultiComplete
              disabled={!form?.client_id?.id || (!!location?.state && !isDuplicate)}
              size={"small"}
              multiple
              id="tags-outlined"
              AutoCompleteList={programList ? programList : []}
              label={
                <>
                  Select Program{" "}
                  <span style={{ color: theme.palette.error.main }}>*</span>
                </>
              }
              value={form?.program_ids}
              isError={errorData?.program_ids}
              errorText={errorData?.program_ids}
              onTextChange={(selectedItems) => {
                changeTextData(selectedItems, "program_ids");
              }}
              enableField={["label"]}
            />
          </div>
        </div>
        <div className={`${styles.formFlex} ${styles.marginLeft}`}>
              <div className={styles.formGroup}>
              { id && !isDuplicate && (
                <CustomTextField
                  isError={errorData?.update_reason}
                  errorText={errorData?.update_reason}
                  label={<>Reason for update <span style={{ color: theme.palette.error.main }}>*</span></>}
                  value={form?.update_reason}
                  multiline
                  rows="3"
                  onTextChange={(text) => {
                    changeTextData(text, "update_reason");
                  }}
                  onBlur={() => {
                    onBlurHandler("update_reason");
                  }}
                />
              )}
              </div>
            </div>
      </ShadowBox>
      <div className={styles.saveButton}>
        <PrimaryButton
          color={"primary"}
          sx={{ mt: 4 }}
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {/* {id ? "SAVE" : "CREATE"} */}
          {isSubmitting ? (
            <CircularProgress size={24} color={"primary"} />
          ) : isDuplicate ? (
            "CREATE"
          ) : id ? (
            "SAVE"
          ) : (
            "CREATE"
          )}
        </PrimaryButton>
      </div>
    </>
  );
};

export default QuizCreate;
